import { render, staticRenderFns } from "./InfoWallet.vue?vue&type=template&id=137955f8&lang=html"
import script from "./InfoWallet.vue?vue&type=script&lang=js"
export * from "./InfoWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports